module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27521",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7171",
      "conversations-error-reporting": "static-1.8447",
      "conversations-internal-pub-sub": "static-1.15521",
      "conversations-internal-schema": "static-1.12181",
      "conversations-message-history": "static-1.11157",
      "conversations-test-sdk": "static-1.9965",
      "conversations-visitor-experience-components": "static-1.20884",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5039",
      "hs-test-utils": "static-1.7463",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10987",
      "I18n": "static-7.1483",
      "jasmine-immutable": "static-1.2483",
      "jasmine-runner": "static-1.5898",
      "quartz": "static-1.6310",
      "react-dlb": "static-1.64",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.4034",
      "viral-links-lib": "static-1.6468",
      "visitor-ui-component-library": "static-1.5676",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.4129",
      "atom": "static-1.4646",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4294",
      "conversations-infrastructure": "static-1.8469",
      "conversations-prop-types": "static-1.6894",
      "conversations-visibility-tools": "static-1.5256",
      "conversations-visitor-message-history": "static-1.19621",
      "cssUtils": "static-1.634",
      "enviro": "static-4.345",
      "flux-actions": "static-1.291",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16166",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4904",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3923",
      "sanitize-text": "static-1.7670",
      "signup-constants": "static-1.17870",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.478",
      "usage-tracker": "static-1.6886",
      "usage-tracker-core": "static-1.6736",
      "usage-tracker-multi": "static-1.5300",
      "usage-tracker-public": "static-1.6697",
      "visitor-ui-component-library-icons": "static-1.5487",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3006",
      "moment": "static-3.26",
      "quartz-config": "static-1.88",
      "quartz-core": "static-1.5529",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4337",
      "foundations-components": "static-1.7040",
      "foundations-theming": "static-1.3877",
      "UIComponents": "static-3.7934",
      "cv-backend-services": "static-1.1383",
      "immutable-less": "static-1.4074",
      "conversations-skeleton-state": "static-1.6820",
      "crm-events-viz-core": "static-1.31706",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4171",
      "tanstack-virtual": "static-1.20",
      "ui-images": "static-2.996",
      "permission-components": "static-1.4833",
      "react-virtualized": "static-2.87",
      "HeadJS": "static-2.646",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2574",
      "msw": "static-1.39",
      "testing-library": "static-1.140",
      "i18n-data": "static-1.211",
      "moment-timezone": "static-5.73",
      "jasmine": "static-4.3791",
      "signup-ui-url-generator": "static-2.7564",
      "HubStyle": "static-2.11295",
      "sassPrefix": "static-1.145",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3495",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5303",
      "bender-build-tools": "static-1.2659",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.723",
      "hub-http-shared-msw-handlers": "static-1.8814",
      "hubspotter-http": "static-1.4159",
      "hubspotter-http-shared-msw-handlers": "static-1.8812",
      "mobile-manifest-mixins": "static-1.419",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.335",
      "hs-story-utils": "static-1.8882",
      "bend-plugin-foundations-components": "static-1.3309",
      "floating-ui": "static-1.46",
      "foundations-theming-specialty": "static-1.1593",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2360",
      "foundations-theming-base": "static-1.2862",
      "stylex": "static-1.22",
      "ts-schema": "static-1.3671",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2017",
      "content-assistance-lib": "static-1.7132",
      "crm-component-utils": "static-1.37831",
      "crm-display-components": "static-1.23581",
      "crm-fe-perf": "static-1.22447",
      "crm-links": "static-1.5706",
      "crm-message-bus": "static-1.41678",
      "crm-search-service-types": "static-1.762",
      "crm-source-interpretation-lib": "static-1.4784",
      "customer-data-communicator": "static-1.44221",
      "customer-data-email": "static-1.17157",
      "customer-data-filters-ui": "static-1.38002",
      "customer-data-objects": "static-1.7158",
      "customer-data-objects-ui-components": "static-1.12511",
      "customer-data-properties": "static-1.49991",
      "customer-data-rte": "static-1.31828",
      "customer-data-ui-utilities": "static-1.9282",
      "data-fetching-client": "static-1.9191",
      "draft-plugins": "static-2.20785",
      "file-manager-components": "static-1.22134",
      "FileManagerCore": "static-1.37633",
      "frontend-preferences-client": "static-1.7472",
      "hubspot-apollo-client": "static-1.4325",
      "hubspot-prosemirror": "static-1.16912",
      "object-comments-thread-lib": "static-1.9478",
      "reference-resolvers-lite": "static-1.7562",
      "ui-addon-upgrades": "static-9.17176",
      "universal-associations-select": "static-1.10491",
      "graphql": "static-1.72",
      "ai-components-ui-library": "static-1.7643",
      "superstore": "static-1.4244",
      "ui-addon-video-player": "static-1.8279",
      "ui-coaching-tips": "static-1.27231",
      "card-properties-lib": "static-1.42832",
      "crm-actions": "static-1.5705",
      "crm-cards-data": "static-1.678",
      "crm-cards-sdk": "static-1.42188",
      "customer-data-properties-shared-msw-handlers": "static-1.8141",
      "customer-data-property-utils": "static-1.7510",
      "customer-data-tracking": "static-1.6398",
      "framework-data-schema-resolvers": "static-1.6372",
      "usage-tracker-container": "static-1.6876",
      "framework-data-table": "static-2.10815",
      "location-customization-utils-lib": "static-1.7791",
      "calling-error-reporting": "static-1.30830",
      "calling-internal-common": "static-1.30824",
      "calling-usage-tracker": "static-1.6044",
      "crm_data": "static-4.90428",
      "crm_schema": "static-3.90467",
      "crm-legacy-global-containers": "static-1.23312",
      "customer-data-content": "static-1.26353",
      "draft-content-plugins": "static-1.27204",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23191",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22900",
      "EmailSignatureEditor": "static-1.23462",
      "FileManagerLib": "static-1.37774",
      "hubspot-prosemirror-plugins": "static-1.16904",
      "integration-settings-components": "static-1.13961",
      "integrations-lib": "static-1.14652",
      "integrations-tracking-lib": "static-1.5141",
      "native-integrations-shared-strings": "static-1.7295",
      "nav-meta": "static-1.28247",
      "onboarding-scopes": "static-1.5993",
      "outreach-assistant-email-generation": "static-1.5288",
      "property-translator": "static-1.4886",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36409",
      "react-colorpicker": "static-2.9741",
      "react-dnd-compat": "static-1.4140",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7724",
      "rich-text-lib": "static-1.18936",
      "sales-email-signature-service-client": "static-1.3403",
      "sequences-lib": "static-1.7302",
      "timezone-utils": "static-2.4708",
      "ui-addon-i18n": "static-1.10543",
      "ui-addon-iframeable": "static-1.8437",
      "ui-business-units-lib": "static-1.8462",
      "ui-gdpr-components": "static-1.9778",
      "ui-shepherd-react": "static-3.9594",
      "user-context": "static-1.4643",
      "whatsapp-sending-lib": "static-1.4259",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4208",
      "salesImages": "static-1.514",
      "customer-data-filters-ui-msw-helpers": "static-1.20436",
      "customer-data-reference-ui-components": "static-1.12575",
      "FormUrlGenerator": "static-2.4187",
      "framework-builder-read-service-client": "static-1.3560",
      "framework-data-schema-quick-fetch": "static-1.6277",
      "inbound-db-meta-service-client": "static-1.3237",
      "inbound-db-properties-service-client": "static-1.3465",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.522",
      "onboarding-tours": "static-1.15918",
      "reporting-datasets-permissions-lib": "static-1.12257",
      "SharedI18nStrings": "static-1.175",
      "ui-addon-teams": "static-1.20892",
      "calling-global-api": "static-1.62864",
      "calling-lifecycle-internal": "static-1.64246",
      "calling-lifecycle-messages": "static-1.56540",
      "commerce-products-lib": "static-1.8074",
      "conditional-properties-service-client": "static-1.3406",
      "external-options-client-types": "static-1.3625",
      "google-libphonenumber": "static-1.27",
      "inbound-db-associations-writes-service-client": "static-1.2728",
      "inbounddb-objects-service-types": "static-1.3712",
      "meetings-icalendar-utils-lib": "static-1.46",
      "multi-currency-client-types": "static-1.3242",
      "object-builder-ui-client": "static-1.47164",
      "pipeline-validation-client-types": "static-1.3466",
      "property-value-citations": "static-1.605",
      "smart-property-lib": "static-1.4962",
      "tiered-pricing": "static-1.434",
      "ui-addon-form-validation": "static-1.10510",
      "immerable": "static-1.3613",
      "video-components-external": "static-1.9873",
      "video-data-lib": "static-1.33531",
      "audio-components": "static-1.5300",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35285",
      "video-components": "static-1.11876",
      "video-embed": "static-1.34365",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23995",
      "knowledge-content-types": "static-1.8144",
      "payment-link-components": "static-1.22300",
      "ui-addon-emoji-picker": "static-1.9411",
      "call-summary": "static-1.37555",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8960",
      "batch-promise": "static-1.1099",
      "fast-json-stable-stringify": "static-1.4",
      "feature-store-service-types": "static-1.4106",
      "growth-monetization-service-types": "static-1.4113",
      "merchandise-lib": "static-1.248",
      "self-service-api": "static-1.9725",
      "upgrade-management-service-types": "static-1.4097",
      "chatspot-client-types": "static-1.10193",
      "chatspot-core": "static-1.19437",
      "ContentUtils": "static-1.66870",
      "copilot-toolkit": "static-1.9835",
      "growth-onboarding-feedback-components": "static-1.6005",
      "customer-data-sidebar": "static-2.44704",
      "enrichment-properties-lib": "static-1.14080",
      "persist-promise": "static-1.3256",
      "crm-pipelines-api-client-types": "static-1.3586",
      "customer-data-associations": "static-1.6774",
      "deal-intel-decorators": "static-1.474",
      "reporting-data": "static-1.65520",
      "ui-addon-draggable": "static-3.4318",
      "crm-record-cards-service-types": "static-1.3195",
      "crm_universal": "static-1.21330",
      "SalesContentIndexUI": "static-3.8411",
      "signup-ui-lego-core": "static-1.19880",
      "content-embed-lib": "static-1.6898",
      "data-model-builder-lib": "static-1.10753",
      "remote-ui": "static-1.55",
      "ui-components-test-utils": "static-1.5125",
      "ui-extensions-remote-renderer": "static-1.15804",
      "universal-page-editor-lib": "static-1.2536",
      "integrations-error-boundary-lib": "static-1.12067",
      "laboratory-lib": "static-3.6646",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9942",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8368",
      "messaging-types-lib": "static-1.44588",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15606",
      "sequences-client-types-lib": "static-1.7159",
      "foundations-components-test-utils": "static-1.4524",
      "magpie-lib": "static-1.5116",
      "navigation-messaging": "static-1.5937",
      "getting-started-shared-tasks": "static-1.17190",
      "getting-started-shared-tasks-store": "static-1.16308",
      "whatsapp-management-lib": "static-1.7418",
      "growth-data-modal": "static-1.4824",
      "growth-onboarding-confetti": "static-1.2560",
      "growth-onboarding-next-action-utils": "static-1.932",
      "navigation-components": "static-1.16610",
      "ui-shepherd-tracker": "static-1.6975",
      "shared-worker-versioning": "static-1.10575",
      "calling-orchestration-shared-library": "static-1.34056",
      "products-iframe-lib": "static-1.6655",
      "products-ui-components-shared-msw-handlers": "static-1.9196",
      "breeze-intelligence-kit": "static-1.4916",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8897",
      "fsm": "static-1.3200",
      "policy-lib": "static-1.6286",
      "react-tinymce": "static-1.53916",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53042",
      "tinymce-plugins": "static-1.56156",
      "tinymce-themes": "static-1.55012",
      "content-media-composition-data-lib": "static-1.10275",
      "content-media-compositions": "static-2.14282",
      "idb-keyval": "static-1.34",
      "magpie-types": "static-1.4576",
      "media-bridge-lib": "static-1.18161",
      "content-icons-ui": "static-1.2049",
      "social-insights-client-types": "static-1.20703",
      "outpost": "static-1.3804",
      "commerce-analytics-service-client": "static-1.3182",
      "ui-addon-opt": "static-4.7955",
      "commerce-tours-lib": "static-1.5314",
      "growth-onboarding-reliability": "static-1.4640",
      "sales-checkout-service-client": "static-1.3194",
      "ai-addon-copilot-preview": "static-1.6855",
      "calling-cross-tab-library": "static-1.18797",
      "wootric-nps": "static-1.6422",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4204",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2499",
      "card-payment-highlight-lib": "static-1.35824",
      "card-subscription-highlight-lib": "static-1.38212",
      "commerce-billing-lib": "static-1.17782",
      "commerce-contract-lib": "static-1.10341",
      "crm_components": "static-3.90428",
      "invoices-highlight-card-lib": "static-1.53243",
      "orders-highlight-card-lib": "static-1.20325",
      "products-highlight-card-lib": "static-1.16358",
      "project-storage": "static-1.4167",
      "quotes-highlight-card-lib": "static-1.70323",
      "usage-based-billing-components-lib": "static-1.7339",
      "deal-intel-utils": "static-1.478",
      "reporting-client-types": "static-1.2281",
      "react-flip-move": "static-1.60",
      "FireAlarmUi": "static-1.4109",
      "sales-templates-service-types-lib": "static-1.3750",
      "ui-asset-management-lib": "static-1.10315",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8953",
      "collaboration-sidebar": "static-1.56533",
      "data-model-commons-lib": "static-1.11309",
      "feedback-loader": "static-1.28320",
      "final-form": "static-1.60",
      "html-to-image": "static-1.44",
      "object-definition-builder-lib": "static-1.6546",
      "property-management-iframe": "static-1.11415",
      "reactflow": "static-1.51",
      "simple-data-table": "static-1.1413",
      "used-in-list-lib": "static-1.6401",
      "visual-association": "static-1.5328",
      "highcharts": "static-8.94",
      "reporting-visualizations": "static-1.57597",
      "ui-extensibility-client-types": "static-1.3533",
      "automation-platform-service-types": "static-1.2353",
      "ContentData": "static-1.66945",
      "email-portal-health-service-types": "static-1.539",
      "marketing-email-service-types": "static-1.1642",
      "reactive-lib": "static-1.249",
      "content-whatsapp-service-types": "static-1.92",
      "marketing-platform-lib": "static-1.6260",
      "purchase-motions-components": "static-1.5031",
      "short-messages-app-service-client": "static-1.3550",
      "ui-tool-access": "static-1.9597",
      "calling-orchestration-schema": "static-1.34281",
      "sales-views-client-types": "static-1.3750",
      "trellis-story-utils": "static-1.4026",
      "storybook-react": "static-1.22",
      "hub-http-contrib": "static-1.2618",
      "interframe": "static-3.4253",
      "tinymce-data": "static-1.39127",
      "ui-addon-sales-email": "static-1.4713",
      "codemirror": "static-5.85",
      "layout-dnd-components": "static-1.11552",
      "layout-dnd-utils": "static-1.10527",
      "react-codemirror": "static-1.10154",
      "ui-brand-identity-lib": "static-1.12752",
      "NamespacedHubStyle": "static-2.8688",
      "hls.js": "static-1.29",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.4132",
      "ai-rendering-library": "static-1.8567",
      "ai-settings-ui-library": "static-1.6956",
      "chirp-fetch": "static-1.1454",
      "copilot-plugins": "static-1.9808",
      "commerce-shared-components-lib": "static-1.17236",
      "commerce-subscription-lib": "static-1.35789",
      "commerce-tools-ui-lib": "static-1.9220",
      "usage-tracker-session-replay": "static-1.4572",
      "utility-belt": "static-1.1994",
      "payments-enrollment-embed-lib": "static-1.21145",
      "quotes-ui-lib": "static-1.79040",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6238",
      "invoices-ui-lib": "static-1.53259",
      "commerce-products-api": "static-1.1505",
      "SafeStorage": "static-1.3855",
      "invoices-iframe-lib": "static-1.55317",
      "quotes-modal-lib": "static-1.100997",
      "reporting-ui-components": "static-2.62794",
      "subscription-experience-data-types": "static-1.14151",
      "association-translator": "static-1.2665",
      "crm-settings-header-lib": "static-1.7745",
      "settings-ui-nav": "static-2.9695",
      "chatspot-widget-iframe": "static-1.19429",
      "collaboration-sidebar-common": "static-1.1329",
      "property-management-common": "static-1.3702",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14399",
      "advanced-menus-lib": "static-1.11422",
      "ExportDialog": "static-6.9951",
      "ui-memberships-settings-lib": "static-1.32696",
      "nav-client-types": "static-1.1791",
      "purchase-motions-api": "static-1.5033",
      "trials-service-types": "static-1.3514",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8852",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12816",
      "highlight.js": "static-1.69",
      "reporting-action-components": "static-1.39989",
      "ui-addon-react-router-dom": "static-1.9087",
      "growth-onboarding-empty-states": "static-1.5022",
      "InboxConnectUtils": "static-4.13591",
      "payments-post-enroll-local-storage-lib": "static-1.4545",
      "qrcode-generator": "static-1.59",
      "amplitude-session-replay-browser": "static-1.50",
      "marketplace-ui-apps-core": "static-1.16782",
      "stripe-embedded-components": "static-1.6734",
      "products-ui-components": "static-1.38593",
      "totals-ui-components": "static-1.22278",
      "reporting-plugins": "static-1.9567",
      "reporting-reports": "static-1.65200",
      "reporting-snowflake": "static-1.54140",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14398",
      "simple-menus-lib": "static-1.15915",
      "eligibility-engine-service-types": "static-1.2795",
      "academy-common-lib": "static-1.12276",
      "dashboard-lib": "static-1.79639",
      "share-with-third-party-component-lib": "static-1.8206",
      "developer-experience-shared-components": "static-1.9920",
      "marketplace-ui-client-types": "static-1.15655",
      "marketplace-ui-common": "static-1.18248",
      "ui-addon-integrations-directory-panel": "static-2.7512",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.254",
      "property-description-translator": "static-1.3331",
      "commerce-totals-service-types": "static-1.3351",
      "campaign-roi-lib": "static-1.7511",
      "academy-service-client": "static-1.3146",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3447",
      "oauth-service-types": "static-1.3756",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27521",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7171",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8447",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15521",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12181",
      "conversations-message-history": "/conversations-message-history/static-1.11157",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9965",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20884",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5039",
      "hs-test-utils": "/hs-test-utils/static-1.7463",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10987",
      "I18n": "/I18n/static-7.1483",
      "jasmine-immutable": "/jasmine-immutable/static-1.2483",
      "jasmine-runner": "/jasmine-runner/static-1.5898",
      "quartz": "/quartz/static-1.6310",
      "react-dlb": "/react-dlb/static-1.64",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4034",
      "viral-links-lib": "/viral-links-lib/static-1.6468",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5676",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4129",
      "atom": "/atom/static-1.4646",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4294",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8469",
      "conversations-prop-types": "/conversations-prop-types/static-1.6894",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5256",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19621",
      "cssUtils": "/cssUtils/static-1.634",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.291",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16166",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4904",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3923",
      "sanitize-text": "/sanitize-text/static-1.7670",
      "signup-constants": "/signup-constants/static-1.17870",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "usage-tracker": "/usage-tracker/static-1.6886",
      "usage-tracker-core": "/usage-tracker-core/static-1.6736",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5300",
      "usage-tracker-public": "/usage-tracker-public/static-1.6697",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5487",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3006",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.88",
      "quartz-core": "/quartz-core/static-1.5529",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4337",
      "foundations-components": "/foundations-components/static-1.7040",
      "foundations-theming": "/foundations-theming/static-1.3877",
      "UIComponents": "/UIComponents/static-3.7934",
      "cv-backend-services": "/cv-backend-services/static-1.1383",
      "immutable-less": "/immutable-less/static-1.4074",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6820",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31706",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4171",
      "tanstack-virtual": "/tanstack-virtual/static-1.20",
      "ui-images": "/ui-images/static-2.996",
      "permission-components": "/permission-components/static-1.4833",
      "react-virtualized": "/react-virtualized/static-2.87",
      "HeadJS": "/HeadJS/static-2.646",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2574",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.140",
      "i18n-data": "/i18n-data/static-1.211",
      "moment-timezone": "/moment-timezone/static-5.73",
      "jasmine": "/jasmine/static-4.3791",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7564",
      "HubStyle": "/HubStyle/static-2.11295",
      "sassPrefix": "/sassPrefix/static-1.145",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3495",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5303",
      "bender-build-tools": "/bender-build-tools/static-1.2659",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.723",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8814",
      "hubspotter-http": "/hubspotter-http/static-1.4159",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8812",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.419",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.335",
      "hs-story-utils": "/hs-story-utils/static-1.8882",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3309",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1593",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2360",
      "foundations-theming-base": "/foundations-theming-base/static-1.2862",
      "stylex": "/stylex/static-1.22",
      "ts-schema": "/ts-schema/static-1.3671",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2017",
      "content-assistance-lib": "/content-assistance-lib/static-1.7132",
      "crm-component-utils": "/crm-component-utils/static-1.37831",
      "crm-display-components": "/crm-display-components/static-1.23581",
      "crm-fe-perf": "/crm-fe-perf/static-1.22447",
      "crm-links": "/crm-links/static-1.5706",
      "crm-message-bus": "/crm-message-bus/static-1.41678",
      "crm-search-service-types": "/crm-search-service-types/static-1.762",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4784",
      "customer-data-communicator": "/customer-data-communicator/static-1.44221",
      "customer-data-email": "/customer-data-email/static-1.17157",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38002",
      "customer-data-objects": "/customer-data-objects/static-1.7158",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12511",
      "customer-data-properties": "/customer-data-properties/static-1.49991",
      "customer-data-rte": "/customer-data-rte/static-1.31828",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9282",
      "data-fetching-client": "/data-fetching-client/static-1.9191",
      "draft-plugins": "/draft-plugins/static-2.20785",
      "file-manager-components": "/file-manager-components/static-1.22134",
      "FileManagerCore": "/FileManagerCore/static-1.37633",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7472",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4325",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16912",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9478",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7562",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17176",
      "universal-associations-select": "/universal-associations-select/static-1.10491",
      "graphql": "/graphql/static-1.72",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7643",
      "superstore": "/superstore/static-1.4244",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8279",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27231",
      "card-properties-lib": "/card-properties-lib/static-1.42832",
      "crm-actions": "/crm-actions/static-1.5705",
      "crm-cards-data": "/crm-cards-data/static-1.678",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42188",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8141",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7510",
      "customer-data-tracking": "/customer-data-tracking/static-1.6398",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6372",
      "usage-tracker-container": "/usage-tracker-container/static-1.6876",
      "framework-data-table": "/framework-data-table/static-2.10815",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7791",
      "calling-error-reporting": "/calling-error-reporting/static-1.30830",
      "calling-internal-common": "/calling-internal-common/static-1.30824",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6044",
      "crm_data": "/crm_data/static-4.90428",
      "crm_schema": "/crm_schema/static-3.90467",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23312",
      "customer-data-content": "/customer-data-content/static-1.26353",
      "draft-content-plugins": "/draft-content-plugins/static-1.27204",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23191",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22900",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23462",
      "FileManagerLib": "/FileManagerLib/static-1.37774",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16904",
      "integration-settings-components": "/integration-settings-components/static-1.13961",
      "integrations-lib": "/integrations-lib/static-1.14652",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5141",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7295",
      "nav-meta": "/nav-meta/static-1.28247",
      "onboarding-scopes": "/onboarding-scopes/static-1.5993",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5288",
      "property-translator": "/property-translator/static-1.4886",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36409",
      "react-colorpicker": "/react-colorpicker/static-2.9741",
      "react-dnd-compat": "/react-dnd-compat/static-1.4140",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7724",
      "rich-text-lib": "/rich-text-lib/static-1.18936",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3403",
      "sequences-lib": "/sequences-lib/static-1.7302",
      "timezone-utils": "/timezone-utils/static-2.4708",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10543",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8437",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8462",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9778",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9594",
      "user-context": "/user-context/static-1.4643",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4259",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4208",
      "salesImages": "/salesImages/static-1.514",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20436",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12575",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4187",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3560",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6277",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3237",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3465",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.522",
      "onboarding-tours": "/onboarding-tours/static-1.15918",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12257",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
      "ui-addon-teams": "/ui-addon-teams/static-1.20892",
      "calling-global-api": "/calling-global-api/static-1.62864",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64246",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56540",
      "commerce-products-lib": "/commerce-products-lib/static-1.8074",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3406",
      "external-options-client-types": "/external-options-client-types/static-1.3625",
      "google-libphonenumber": "/google-libphonenumber/static-1.27",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2728",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3712",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.46",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3242",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47164",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3466",
      "property-value-citations": "/property-value-citations/static-1.605",
      "smart-property-lib": "/smart-property-lib/static-1.4962",
      "tiered-pricing": "/tiered-pricing/static-1.434",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10510",
      "immerable": "/immerable/static-1.3613",
      "video-components-external": "/video-components-external/static-1.9873",
      "video-data-lib": "/video-data-lib/static-1.33531",
      "audio-components": "/audio-components/static-1.5300",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35285",
      "video-components": "/video-components/static-1.11876",
      "video-embed": "/video-embed/static-1.34365",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23995",
      "knowledge-content-types": "/knowledge-content-types/static-1.8144",
      "payment-link-components": "/payment-link-components/static-1.22300",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9411",
      "call-summary": "/call-summary/static-1.37555",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8960",
      "batch-promise": "/batch-promise/static-1.1099",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "feature-store-service-types": "/feature-store-service-types/static-1.4106",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4113",
      "merchandise-lib": "/merchandise-lib/static-1.248",
      "self-service-api": "/self-service-api/static-1.9725",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4097",
      "chatspot-client-types": "/chatspot-client-types/static-1.10193",
      "chatspot-core": "/chatspot-core/static-1.19437",
      "ContentUtils": "/ContentUtils/static-1.66870",
      "copilot-toolkit": "/copilot-toolkit/static-1.9835",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6005",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44704",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14080",
      "persist-promise": "/persist-promise/static-1.3256",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3586",
      "customer-data-associations": "/customer-data-associations/static-1.6774",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.474",
      "reporting-data": "/reporting-data/static-1.65520",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4318",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3195",
      "crm_universal": "/crm_universal/static-1.21330",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8411",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19880",
      "content-embed-lib": "/content-embed-lib/static-1.6898",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10753",
      "remote-ui": "/remote-ui/static-1.55",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5125",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15804",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2536",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12067",
      "laboratory-lib": "/laboratory-lib/static-3.6646",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9942",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8368",
      "messaging-types-lib": "/messaging-types-lib/static-1.44588",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15606",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7159",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4524",
      "magpie-lib": "/magpie-lib/static-1.5116",
      "navigation-messaging": "/navigation-messaging/static-1.5937",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17190",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16308",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7418",
      "growth-data-modal": "/growth-data-modal/static-1.4824",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2560",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.932",
      "navigation-components": "/navigation-components/static-1.16610",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6975",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10575",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34056",
      "products-iframe-lib": "/products-iframe-lib/static-1.6655",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9196",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4916",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8897",
      "fsm": "/fsm/static-1.3200",
      "policy-lib": "/policy-lib/static-1.6286",
      "react-tinymce": "/react-tinymce/static-1.53916",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53042",
      "tinymce-plugins": "/tinymce-plugins/static-1.56156",
      "tinymce-themes": "/tinymce-themes/static-1.55012",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10275",
      "content-media-compositions": "/content-media-compositions/static-2.14282",
      "idb-keyval": "/idb-keyval/static-1.34",
      "magpie-types": "/magpie-types/static-1.4576",
      "media-bridge-lib": "/media-bridge-lib/static-1.18161",
      "content-icons-ui": "/content-icons-ui/static-1.2049",
      "social-insights-client-types": "/social-insights-client-types/static-1.20703",
      "outpost": "/outpost/static-1.3804",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
      "ui-addon-opt": "/ui-addon-opt/static-4.7955",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5314",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4640",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6855",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18797",
      "wootric-nps": "/wootric-nps/static-1.6422",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4204",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2499",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35824",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38212",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17782",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10341",
      "crm_components": "/crm_components/static-3.90428",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53243",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20325",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16358",
      "project-storage": "/project-storage/static-1.4167",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70323",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7339",
      "deal-intel-utils": "/deal-intel-utils/static-1.478",
      "reporting-client-types": "/reporting-client-types/static-1.2281",
      "react-flip-move": "/react-flip-move/static-1.60",
      "FireAlarmUi": "/FireAlarmUi/static-1.4109",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3750",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10315",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8953",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56533",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11309",
      "feedback-loader": "/feedback-loader/static-1.28320",
      "final-form": "/final-form/static-1.60",
      "html-to-image": "/html-to-image/static-1.44",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6546",
      "property-management-iframe": "/property-management-iframe/static-1.11415",
      "reactflow": "/reactflow/static-1.51",
      "simple-data-table": "/simple-data-table/static-1.1413",
      "used-in-list-lib": "/used-in-list-lib/static-1.6401",
      "visual-association": "/visual-association/static-1.5328",
      "highcharts": "/highcharts/static-8.94",
      "reporting-visualizations": "/reporting-visualizations/static-1.57597",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3533",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2353",
      "ContentData": "/ContentData/static-1.66945",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.539",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1642",
      "reactive-lib": "/reactive-lib/static-1.249",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.92",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6260",
      "purchase-motions-components": "/purchase-motions-components/static-1.5031",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3550",
      "ui-tool-access": "/ui-tool-access/static-1.9597",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34281",
      "sales-views-client-types": "/sales-views-client-types/static-1.3750",
      "trellis-story-utils": "/trellis-story-utils/static-1.4026",
      "storybook-react": "/storybook-react/static-1.22",
      "hub-http-contrib": "/hub-http-contrib/static-1.2618",
      "interframe": "/interframe/static-3.4253",
      "tinymce-data": "/tinymce-data/static-1.39127",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4713",
      "codemirror": "/codemirror/static-5.85",
      "layout-dnd-components": "/layout-dnd-components/static-1.11552",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10527",
      "react-codemirror": "/react-codemirror/static-1.10154",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12752",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8688",
      "hls.js": "/hls.js/static-1.29",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4132",
      "ai-rendering-library": "/ai-rendering-library/static-1.8567",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6956",
      "chirp-fetch": "/chirp-fetch/static-1.1454",
      "copilot-plugins": "/copilot-plugins/static-1.9808",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17236",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35789",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9220",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4572",
      "utility-belt": "/utility-belt/static-1.1994",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21145",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79040",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6238",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53259",
      "commerce-products-api": "/commerce-products-api/static-1.1505",
      "SafeStorage": "/SafeStorage/static-1.3855",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55317",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100997",
      "reporting-ui-components": "/reporting-ui-components/static-2.62794",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14151",
      "association-translator": "/association-translator/static-1.2665",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7745",
      "settings-ui-nav": "/settings-ui-nav/static-2.9695",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19429",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1329",
      "property-management-common": "/property-management-common/static-1.3702",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14399",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11422",
      "ExportDialog": "/ExportDialog/static-6.9951",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32696",
      "nav-client-types": "/nav-client-types/static-1.1791",
      "purchase-motions-api": "/purchase-motions-api/static-1.5033",
      "trials-service-types": "/trials-service-types/static-1.3514",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8852",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12816",
      "highlight.js": "/highlight.js/static-1.69",
      "reporting-action-components": "/reporting-action-components/static-1.39989",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9087",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5022",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13591",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4545",
      "qrcode-generator": "/qrcode-generator/static-1.59",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.50",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16782",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6734",
      "products-ui-components": "/products-ui-components/static-1.38593",
      "totals-ui-components": "/totals-ui-components/static-1.22278",
      "reporting-plugins": "/reporting-plugins/static-1.9567",
      "reporting-reports": "/reporting-reports/static-1.65200",
      "reporting-snowflake": "/reporting-snowflake/static-1.54140",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14398",
      "simple-menus-lib": "/simple-menus-lib/static-1.15915",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2795",
      "academy-common-lib": "/academy-common-lib/static-1.12276",
      "dashboard-lib": "/dashboard-lib/static-1.79639",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8206",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9920",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15655",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18248",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7512",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.254",
      "property-description-translator": "/property-description-translator/static-1.3331",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3351",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7511",
      "academy-service-client": "/academy-service-client/static-1.3146",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3447",
      "oauth-service-types": "/oauth-service-types/static-1.3756",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};